import "./index.css";

function TodoError() {
  return (
    <div className="error">
      <h2>Hubo un error!</h2>
      <p>Prueba limpiando el localStorage</p>
    </div>
  );
}

export { TodoError };
